import { IHousingObjectResponse } from '@/types';
import { generateListingDetailSchema } from './generateListingDetailSchema';

const BASE_URL = process.env.BASE_URL ?? 'https://alleimmobilien.at';

export const buildListingListItems = (
  objects: IHousingObjectResponse[],
  locale: string,
  section: 'housing' | 'project' = 'housing',
) =>
  objects.map((obj, index) => {
    const slugId = obj.slug ? `${obj.slug}__${obj.id}` : String(obj.id);
    const url = `${BASE_URL}/${locale}/${section}/${slugId}`;
    return {
      '@type': 'ListItem',
      position: index + 1,
      item: generateListingDetailSchema(obj, url),
    };
  });
